module.exports = __webpack_public_path__ + "static/img/Saint-Quentin-en-Yvelines-BMX-Stadium.c3448fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Saint-Quentin-en-Yvelines-BMX-Stadium.jpg
// module id = Y1Ut
// module chunks = 0